<div class="fn-account-info" *ngIf="this.accountInfo">
  <div class="fn-account-info__title">
    <span class="fn-account-info__title-text"> Información de cuenta </span>
  </div>
  <div class="fn-account-info__data">
    <div class="fn-account-info__data-field">
      <span class="fn-account-info__data-field-key"> Cuenta </span>
      <span class="fn-account-info__data-field-value">
        {{ this.accountInfo.accountNumber }}
      </span>
    </div>
    <div class="fn-account-info__data-field">
      <span class="fn-account-info__data-field-key"> Moneda </span>
      <span class="fn-account-info__data-field-value">
        {{ this.accountInfo.currency }}
      </span>
    </div>
    <div class="fn-account-info__data-field">
      <span class="fn-account-info__data-field-key"> Fecha de creación </span>
      <span class="fn-account-info__data-field-value">
        {{ this.accountInfo.creationDate | customDate }}
      </span>
    </div>
    <div class="fn-account-info__data-field">
      <span class="fn-account-info__data-field-key"> Saldo </span>
      <span class="fn-account-info__data-field-value__amount">
        {{ this.accountInfo.balance | amount : true : "$" }}
      </span>
    </div>
  </div>
</div>
